/**
 * Returns true when a category title represents the "Uncategorized" bucket —
 * either an explicit "Uncategorized" label (case-insensitive) or an absent title.
 */
export const isCategoryUncategorized = (title: string | undefined): boolean =>
    !title || title.trim().toLowerCase() === 'uncategorized';
